import React, { useContext } from 'react'
import { GlobalContext } from '../providers/GlobalContextProvider'

const useGlobalContext = () => {
  return useContext(GlobalContext)
}

export default useGlobalContext
